import {
    all,
    fork
} from 'redux-saga/effects';
import {
    watchUpdateAccount,
    watchUpdateDetailedProfileFormViewed,
    watchGetRedemptionAccounts,
    watchGetRedemptionAccountToken,
    watchGetAccount,
    watchUpdateProfileImage
} from "./user";
import {
    watchGetFavorites,
    watchPostFavorite,
    watchPostUnfavorite, watchSubmitCreditRequestForm
} from "./account";

import {
    watchGetGuestCheckout,
    watchUpdateGuestCheckout,
    watchSubmitGuestCheckout,
    watchUpdateGuestCheckoutCartItem,
    watchGuestCheckoutRemoveCartItem,
    watchUpdateGuestCheckoutPurchaserDelivery,
} from "./guestCheckout";
import {
    watchCheckVideoTranscodeStatus,
    watchFetchAwsUploadDetails,
    watchStartVideoTranscode,
    watchUpdateActiveItem,
    watchUploadVideo,
    watchUploadImageToS3,
    watchUploadCustomPhotoToS3,
} from "./store";
import {
    watchSendReminder,
    watchFetchLink,
    watchLinkRedemptionAccount,
    watchGetGift,
    watchGetGiftFromHash,
    watchGetEGift,
    watchConnectCard,
    watchDisconnectCard,
    watchGetExchangeOptions,
    watchConvertToEGift,
    watchUpdateGiftBalance,
    watchDeleteRedemptionAccount,
    watchCreateGiftRedemptionAccountLink, watchReorderGift,
    watchGetReceivedGifts,
    watchGetOrder,
    watchChangeGiftRecipient,
    watchChangeGiftDateSend,
    watchExchangeGiftMerchant,
    watchExchangeGiftVirtualVisa,
    watchSendThankYa,
    watchPollEGift,
    watchGetSentGifts,
    watchExchangeGiftPhysicalVisa,
    watchSelfGiftChangeGiftRecipient,
    watchRefundGift,
    watchCreatePaymentMethodWithRedemptionAccount, watchGiftYaSelectSelectMerchant
} from "./gift";
import {
    watchGetContent
} from "./content";
import {
    watchSendText,
    watchLogin,
    watchGetToken,
    watchLoginStep1ConfirmationCode,
    watchGetIdpAuthenticationUrl,
    watchIpdLogin,
    watchConfirmSocialLoginAccount,
    watchGetConfirmationCodeForSocialLogin,
    // watchGetConfirmationCodeForAccountExistsSocialLogin,
    watchConfirmSocialLoginAccountAccountExists,
    watchConfirmLogin,
    watchSendConfirmationCode, watchGetUserIdpAccounts, watchLinkUserIdpAccount, watchDeleteUserIdpAccount, watchResendConfirmationCodeForSocialLogin
} from "./security";
import {
    watchSubmitSupportForm
} from "./support";
import {
    watchReady
} from "./ready";
import {
    watchGetPromotions
} from "./promotion";
import {
    watchFetchMerchantPageContent,
    watchFetchYelpImagesForMerchants,
    watchUploadYelpImageToS3,
    watchIsYelpImageOk,
    watchGetMerchantOnboardingContent,
    watchPostMerchantOnboardingPartnerForm,
    watchGetMerchantDealLocations,
    watchGetMerchantDealsByLocation,
    watchRedeemMerchantDeal,
    watchGetAccessDevelopmentMerchantCount
} from "./merchant";
import {
    watchAddToCart
} from "./cart";
import {watchCreatePaymentIntent, watchUpdateBillingAddress, watchUpdatePaymentIntent} from "./stripe";
import {watchGetZelleUser, watchLookupZelleUser, watchSubmitZelleRequest} from "./zelle";

export default function* rootSaga() {
  yield all([
      fork(watchAddToCart),
      fork(watchChangeGiftRecipient),
      fork(watchChangeGiftDateSend),
      fork(watchSendReminder),
      fork(watchFetchLink),
      fork(watchUpdateAccount),
      fork(watchCreateGiftRedemptionAccountLink),
      fork(watchLinkRedemptionAccount),
      fork(watchUpdateDetailedProfileFormViewed),
      fork(watchUpdateActiveItem),
      fork(watchFetchAwsUploadDetails),
      fork(watchUploadVideo),
      fork(watchStartVideoTranscode),
      fork(watchCheckVideoTranscodeStatus),
      fork(watchGetContent),
      fork(watchReady),
      fork(watchGetPromotions),
      fork(watchFetchMerchantPageContent),
      fork(watchUploadImageToS3),
      fork(watchFetchYelpImagesForMerchants),
      fork(watchUploadYelpImageToS3),
      fork(watchUploadCustomPhotoToS3),
      fork(watchGetGift),
      fork(watchGetEGift),
      fork(watchGetRedemptionAccounts),
      fork(watchGetRedemptionAccountToken),
      fork(watchConnectCard),
      fork(watchDisconnectCard),
      fork(watchDeleteRedemptionAccount),
      fork(watchGetExchangeOptions),
      fork(watchConvertToEGift),
      fork(watchUpdateGiftBalance),
      fork(watchGetAccount),
      fork(watchReorderGift),
      fork(watchGetReceivedGifts),
      fork(watchGetOrder),
      fork(watchExchangeGiftMerchant),
      fork(watchExchangeGiftVirtualVisa),
      fork(watchPollEGift),
      fork(watchGetFavorites),
      fork(watchPostFavorite),
      fork(watchPostUnfavorite),
      fork(watchSendThankYa),
      fork(watchGetSentGifts),
      fork(watchSubmitSupportForm),
      fork(watchGetGiftFromHash),
      fork(watchIsYelpImageOk),
      fork(watchExchangeGiftPhysicalVisa),
      fork(watchGetGuestCheckout),
      fork(watchSubmitGuestCheckout),
      fork(watchUpdateGuestCheckout),
      fork(watchSendText),
      fork(watchLogin),
      fork(watchUpdateGuestCheckoutCartItem),
      fork(watchUpdateGuestCheckoutPurchaserDelivery),
      fork(watchUpdateProfileImage),
      fork(watchGuestCheckoutRemoveCartItem),
      fork(watchGetToken),
      fork(watchGetMerchantOnboardingContent),
      fork(watchPostMerchantOnboardingPartnerForm),
      fork(watchSelfGiftChangeGiftRecipient),
      fork(watchRefundGift),
      fork(watchCreatePaymentMethodWithRedemptionAccount),
      fork(watchGetMerchantDealLocations),
      fork(watchGetMerchantDealsByLocation),
      fork(watchRedeemMerchantDeal),
      fork(watchGetAccessDevelopmentMerchantCount),
      fork(watchGiftYaSelectSelectMerchant),
      fork(watchLoginStep1ConfirmationCode),
      fork(watchCreatePaymentIntent),
      fork(watchUpdatePaymentIntent),
      fork(watchGetIdpAuthenticationUrl),
      fork(watchIpdLogin),
      fork(watchConfirmSocialLoginAccount),
      fork(watchGetConfirmationCodeForSocialLogin),
      fork(watchConfirmSocialLoginAccountAccountExists),
      fork(watchConfirmLogin),
      fork(watchSendConfirmationCode),
      fork(watchGetUserIdpAccounts),
      fork(watchLinkUserIdpAccount),
      fork(watchDeleteUserIdpAccount),
      fork(watchResendConfirmationCodeForSocialLogin),
      fork(watchUpdateBillingAddress),
      fork(watchUpdateBillingAddress),
      fork(watchSubmitCreditRequestForm),
      fork(watchGetZelleUser),
      fork(watchLookupZelleUser),
      fork(watchSubmitZelleRequest)
  ]);
}
